import React from "react";
import { Button } from "@/components/ui/button";

/**
 * Empty state block — use when a list/table returns nothing.
 * - eyebrow: tiny label above title (optional)
 * - title: main headline
 * - description: helper text
 * - icon: Lucide component to render (optional)
 * - action: { label, onClick, testId } (optional)
 * - secondary: { label, onClick, testId } (optional)
 */
export function EmptyState({ icon: Icon, eyebrow, title, description, action, secondary, testId, className = "" }) {
  return (
    <div
      className={`text-center py-12 px-6 rounded-2xl border border-dashed border-[#E4DFCF] bg-[#F6F1E1]/40 ${className}`}
      data-testid={testId || "empty-state"}
    >
      {Icon && (
        <div className="mx-auto w-14 h-14 rounded-full bg-[#F1EDDF] flex items-center justify-center mb-4">
          <Icon size={26} strokeWidth={1.5} className="text-[#0F5E39]" />
        </div>
      )}
      {eyebrow && (
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#C9A24B] mb-2">
          {eyebrow}
        </div>
      )}
      <div className="font-serif text-2xl text-[#0F1E15] mb-2">{title}</div>
      {description && (
        <p className="text-sm text-[#4A5A50] max-w-md mx-auto">{description}</p>
      )}
      {(action || secondary) && (
        <div className="mt-6 flex items-center justify-center gap-2 flex-wrap">
          {action && (
            <Button
              onClick={action.onClick}
              className="rounded-full bg-[#0F5E39] hover:bg-[#083F22] text-white h-11 px-6"
              data-testid={action.testId}
            >
              {action.label}
            </Button>
          )}
          {secondary && (
            <Button
              variant="outline"
              onClick={secondary.onClick}
              className="rounded-full border-[#0F5E39] text-[#0F5E39] hover:bg-[#0F5E39]/10 h-11 px-6"
              data-testid={secondary.testId}
            >
              {secondary.label}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
